
namespace RioERP.Carts {

    @Serenity.Decorators.registerClass()
    export class FranchiseeProductCategoryGrid extends Serenity.EntityGrid<FranchiseeProductCategoryRow, any> {
        protected getColumnsKey() { return FranchiseeProductCategoryColumns.columnsKey; }
        protected getDialogType() { return FranchiseeProductCategoryDialog; }
        protected getIdProperty() { return FranchiseeProductCategoryRow.idProperty; }
        protected getInsertPermission() { return FranchiseeProductCategoryRow.insertPermission; }
        protected getLocalTextPrefix() { return FranchiseeProductCategoryRow.localTextPrefix; }
        protected getService() { return FranchiseeProductCategoryService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}